import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import ApplicationStatisticModel from "../../../viewModels/Applications/ApplicationStatisticModel";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  exportLoading: boolean;
  statistics?: Array<ApplicationStatisticModel>;
} = {
  loading: true,
  loadingData: true,
  exportLoading: false,
};

const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {
    loadStatistics(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
    loadStatisticsSuccess(state, action: PayloadAction<Array<ApplicationStatisticModel>>) {
      state.loadingData = false;
      state.statistics = action.payload;
    },
    exportProductAnalytics(state, _action: PayloadAction<{ dateFrom: string; dateTo: string }>) {
      state.exportLoading = true;
    },
    exportProductAnalyticsSuccess(state) {
      state.exportLoading = false;
    },
    exportProductAnalyticsReject(state) {
      state.exportLoading = false;
    },
  },
});

export default statisticsSlice;
